import {
  TOOLTIP_FLIP_HEIGHT_PX,
  TOOLTIP_FLIP_WIDTH_PX,
  TOOLTIP_OFFSET_PX,
} from "../../constants";
import type { GetTooltipTransform } from "./types";

// Transform only, never left/top: moving a fixed element by transform costs no layout, so following the cursor is free.
export const getTooltipTransform: GetTooltipTransform = ({
  x,
  y,
  viewportWidth,
  viewportHeight,
}) => {
  const isFlippedLeft = x + TOOLTIP_FLIP_WIDTH_PX > viewportWidth;
  const isFlippedUp = y + TOOLTIP_FLIP_HEIGHT_PX > viewportHeight;
  const left = x + (isFlippedLeft ? -TOOLTIP_OFFSET_PX : TOOLTIP_OFFSET_PX);
  const top = y + (isFlippedUp ? -TOOLTIP_OFFSET_PX : TOOLTIP_OFFSET_PX);
  const shiftX = isFlippedLeft ? "-100%" : "0";
  const shiftY = isFlippedUp ? "-100%" : "0";
  return `translate(${left}px, ${top}px) translate(${shiftX}, ${shiftY})`;
};
